import React from "react";
import Loader from "../Loader/Loader";
import styles from "./SearchBox.module.css";
import Search from "../../../assets/search.svg";

export default function SearchBox({
	value,
	onChange,
	onEnter,
	isLoading,
	onSearch,
}) {
	return (
		<div className={styles.searchBox}>
			<input
				type="text"
				autoComplete="off"
				placeholder="Search"
				value={value}
				onChange={onChange}
				onKeyDown={onEnter}
			/>
			{isLoading ? (
				<Loader />
			) : (
				<img
					className={styles.icon}
					src={Search}
					alt=""
					onClick={onSearch}
				/>
			)}
		</div>
	);
}
